import permissions, { RESOURCE_ACTIVO_FIJO_PG } from '@/auth/permissions/modules/activoFijoPg'
import {
    ROUTE_CONFIGURAR_NIVEL_APROBACION_SOLICITUD_TRANSFERENCIA,
    ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
    ROUTE_PERMISOS_TIPOS_ACTIVOS_FIJOS,
} from '@/router/routes/activo-fijo-pg/names'
import { defineMenu } from '@/utils/menu'

const { configuracion } = permissions

export default defineMenu([
    {
        title: 'activo_fijo_pg.subopciones.tipos_activos_fijos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: configuracion.tipoActivoFijo,
        route: ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.nivel_aprobacion_solicitud_transferencia',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: configuracion.nivelAprobacionSolicitudTransferencia,
        route: ROUTE_CONFIGURAR_NIVEL_APROBACION_SOLICITUD_TRANSFERENCIA,
    },
    {
        title: 'activo_fijo_pg.subopciones.permisos_tipos_activos_fijos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: configuracion.permisosTiposActivoFijo,
        route: ROUTE_PERMISOS_TIPOS_ACTIVOS_FIJOS,
    },
])
